import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {
  AcceptRejectConfirmationModalComponent
} from 'src/app/admin/company/accept-reject-confirmation-modal/accept-reject-confirmation-modal.component';
import {StorageKeys} from 'src/app/share/enums/storage.enum';
import {UserSettingService} from 'src/app/share/services/User-Setting/user-setting.service';
import {StorageService} from 'src/app/share/services/storage-service/storage.service';
import {environment} from '../../../../environments/environment';
import {APPTYPES} from 'src/app/share/constants/common-constants';
import {CommonService} from 'src/app/share/services/common/common.service';
import {DocumentValutService} from 'src/app/share/document-valut/document-valut.service';
import {ViewDocumentComponent} from 'src/app/document-valut/view-document/view-document.component';
import { LookupService } from 'src/app/share/services/lookup/lookup.service';
import { ConfirmationPopupComponent } from 'src/app/share/popups/confirmation-popup/confirmation-popup.component';

@Component({
    selector: 'app-user-details',
    templateUrl: './user-details.component.html',
    styleUrls: ['./user-details.component.scss'],
    standalone: false
})

export class UserDetailsComponent implements OnInit {
  @Input() companyId        : any;
  @Input() parentData       : any;
  @Input() permissionData   : any;
  @Output() closePanel      : EventEmitter<void> = new EventEmitter<void>();
  @Output() editUser        : EventEmitter<any> = new EventEmitter<any>();
  @Output() userDeleted     : EventEmitter<any> = new EventEmitter<any>();
  @Output() disableMfa      : EventEmitter<any> = new EventEmitter<any>();
  @Output() departmentUpdated: EventEmitter<void> = new EventEmitter<void>();
  userId                    : string;
  selfDetails               : any;
  isAdmin                   : boolean = false;
  isEsignApplicable         : boolean = true;
  isBlockChainApplicable    : boolean = true;
  isMFA                     : boolean = false;
  envType = environment?.envType || 'SDEX';
  appType = APPTYPES;
  isToaster                 : boolean = false;
  message                   : string;
  departmentDisplay         : string = '';
  departmentPage            : number = 0;
  departmentList            : any[] = [];
  isDepartmentLoading       : boolean = false;
  hasMoreDepartment         : boolean = true;
  previousSeletedDepartment : any;
  lastSearchQuery           : string;
  selectedDepartment        : any;
  isEditingDepartment       : boolean = false;
  editedDepartment          : any = null;
  companyid                 : any;
  isSuccessToster           : boolean = false;
  successMessage            : any;
  errorMessage              : any;
  loadAction                : boolean = false;
  companyPrefs              : any;


  constructor(
    private readonly modal: NgbModal,
    private readonly storageService: StorageService,
    private readonly userSettingService:UserSettingService,
    public commonService         : CommonService,
    private readonly documentService: DocumentValutService,
    private readonly lookupService: LookupService,
  ) { }

  onCloseIconClick() {
    this.closePanel.emit();
    document.body.classList.remove('panel-open');
  }

  ngOnInit(): void {
    if(this.parentData!== undefined){
    this.parentData = structuredClone(this.parentData);
    }
    this.selfDetails = this.storageService.getDataFromLocalStorage(StorageKeys.SELF_DETAILS);
    if (this.selfDetails) {
      this.userId = this.selfDetails._id;
      this.companyid = this.selfDetails?.company;
    }
    if (this.selfDetails?.enrollmentType === "Admin") {
      this.isAdmin = true;
    }
    if (Array.isArray(this.parentData?.departments) && this.parentData.departments.length > 0) {
      this.departmentDisplay = this.parentData.departments.map((d: any) => d?.name).filter(Boolean).join(', ');
    }
    this.getCompanyPrefs();
    this.getBlockChainKey();
    this.previousSeletedDepartment = this.parentData?.departments?.[0]?.name;
  }

  getCompanyPrefs() {
    this.userSettingService.getCompanyPrefs()?.subscribe({
      next: (response: any) => {
        this.companyPrefs = response?.data || {};
      },
      error: () => {
        this.companyPrefs = {};
      }
    });
  }

  deleteUser(id: string) {
    let dialogRef = this.modal.open(AcceptRejectConfirmationModalComponent, {
      backdrop: 'static',
      size: 'md',
      keyboard: false,
      centered: false,
    });
    dialogRef.componentInstance.userId = this.parentData?._id;
    dialogRef.componentInstance.buttonLabel = this.parentData?.status == 'Active' ? 'Lock' : 'Unlock';
    dialogRef.componentInstance.message = `Are you sure you want to ${this.parentData?.status == 'Active' ? 'lock' : 'unlock'} the user '${this.parentData.name ? this.parentData.name : ""}' ?`;
    dialogRef.result.then(
      (result) => {
        if (result?.status) {
          const action = this.parentData?.status === 'Active' ? 'locked' : 'unlocked';
          let message = `User '${this.parentData.name}' has been ${action} successfully!`;
          this.isToaster = true;
          this.closePanel.emit();
          this.userDeleted.emit({isToaster:true,message:message});
          document.body.classList.remove('panel-open');

        }

      },
      (reason) => {

      }
    );
  }


  closeToaster(){
    this.isToaster =false;
  }
  handleEditUser() {
    this.editUser.emit(this.parentData);
  }

  getBlockChainKey() {
    this.userSettingService.getblockchainkey(this.parentData?._id)?.subscribe(response => {
      this.parentData.isKeyGenerated = response.data.keyGenerated;
    });
  }

  disabledMFA() {
    this.disableMfa.emit();
  }

  closeMFAPanel(){
    this.isMFA = false;
  }
  onChange(e: any) {
    console.log(e);
  }

  getFile(id: string) {
    this.documentService.getFileById(id).subscribe((res: any) => {
      this.viewFile(res?.data);
    })
  }

  viewFile(file: any) {
    this.parentData.downloadLoader = true;
    this.documentService.exportEsignDocument({ _id: file._id, download: true }, true)?.subscribe({
      next: (response: any) => {
        file.isViewLoader = false;
        let viewDetails = { file: file, data: response };
        let files = new Blob([viewDetails?.data?.body], {
          type: viewDetails?.file?.mimeType
        });
        let pdfSrc = URL.createObjectURL(files);
        const modelRef = this.modal.open(ViewDocumentComponent, {
          ariaLabelledBy: 'modal-basic-title',
          size: 'lg',
        });
        this.parentData.downloadLoader = false;
        if (modelRef?.componentInstance) {
          modelRef.componentInstance.viewDetails = viewDetails;
          modelRef.componentInstance.pdfSrc = pdfSrc;
          modelRef.componentInstance.isSearch = true;
          modelRef.componentInstance.viewEsign = true;
          modelRef.result.finally(() => {
            this.parentData.downloadLoader = false;
          });
        }
      },
      error: (err: any) => {
        this.parentData.downloadLoader = false;
      }
    })
  }

  getDepartmentsList(query: string = '') {
    if (this.isDepartmentLoading) return;
    if (query !== this.lastSearchQuery) {
      this.departmentPage = 0;
      this.departmentList = [];
      this.hasMoreDepartment = true;
      this.lastSearchQuery = query;
    }
    if (!this.hasMoreDepartment) return;
    this.isDepartmentLoading = true;
    this.lookupService.getDepartmentList(this.companyid, {
      page: this.departmentPage,
      name: this.lastSearchQuery || '',
      userId: this.parentData?._id
    }).subscribe({
      next: (res: any) => {
        if (res?.data?.length) {
          this.departmentList = [
            ...res.data.map((x: any) => ({
              _id: x._id,
              name: x.name
            }))
          ];
          this.departmentPage++;
        } else {
          this.hasMoreDepartment = false;
        }
        this.isDepartmentLoading = false;
      }
    });
  }

  onSelectedDepartment(value: any) {
    this.selectedDepartment = value._id;
  }

  editDepartment() {
    this.isEditingDepartment = true;
    this.editedDepartment = this.parentData?.departments?.[0] || null;
    this.selectedDepartment = this.editedDepartment?._id || null;
    this.getDepartmentsList();
  }

  saveDepartment(update: boolean) {
    let payload: any = {
      userId: this.parentData?._id,
    };
    if (update) {
      payload.departmentIds = [this.selectedDepartment]
    } else {
      payload.departmentIds = []
    }
    this.loadAction = true;
    this.lookupService.assignDepartment(payload, this.companyid).subscribe({
      next: (res: any) => {
        if (update) {
          const selected = this.departmentList.find(dep => dep._id === this.selectedDepartment);
          if (selected) {
            this.parentData.departments = [selected];
            this.departmentDisplay = selected.name;
          }
        } else {
          this.parentData.departments = [];
          this.departmentDisplay = '';
          this.previousSeletedDepartment = ''
        }
        this.isEditingDepartment = false;
        this.loadAction = false;
        this.isSuccessToster = true;
        this.successMessage = res?.data?.message;
        this.departmentUpdated.emit();
      },
      error: (error: any) => {
        this.loadAction = false;
        this.errorMessage = error?.error?.error?.message;
      }
    });
  }

  cancelEditDepartment() {
    this.isEditingDepartment = false;
    const selected = this.parentData?.departments?.[0];
    this.selectedDepartment = selected?._id;
    this.departmentDisplay = selected?.name || '';
  }

  closeToster(value: boolean) {
    this.isSuccessToster = value;
  }

  unAssignDepartment() {
    let dialogRef = this.modal.open(ConfirmationPopupComponent, { keyboard: false, backdrop: "static" });

    if (dialogRef?.componentInstance) {
      dialogRef.componentInstance.header = 'Confirm unassign department to user';
      dialogRef.componentInstance.message = `Are you sure you want to unassign department`;
      dialogRef.componentInstance.lableName = 'Unassign';
      dialogRef.result.then(
        (result) => {
          if (result) {
            this.saveDepartment(false)
          }
        },
      );
    }
  }

}
